export function showElements(array: Array<HTMLElement>) {
    array.forEach(el => {
        el.classList.remove('hidden');
    });
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/show-elements.ts